import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  isStoreOrderFetching: true,
  isStoreOrderFetched: false,
  isStoreAccessibilityFetched: false,
};

const syncReducers = {
  setStore: (state, { payload }) => {
    return { ...state, ...payload };
  },
  setStoreBalance: (state, { payload }) => {
    return {
      ...state,
      ...payload,
      isStoreOrderFetching: false,
    };
  },
  updateStoreConfig: (state, { payload }) => {
    return { ...state, config: { ...state.config, ...payload } };
  },
  clearStore: () => {
    return INITIAL_STATE;
  },
};

const store = createSlice({
  name: "store",
  initialState: INITIAL_STATE,
  reducers: syncReducers,
});

export const { setStore, setStoreBalance, clearStore, updateStoreConfig } = store.actions;

export default store.reducer;
